import { useEffect, useState } from "react";
import axios from "axios";

import styles from "./FileList.module.css";

export default function FileList(props) {
  const { api, article_id } = props;
  let [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/api/${api}/article/${article_id}/files`
      )
      .then((res) => {
        if (res.data.length !== 0) {
          setData([...data, ...res.data]);
        }
      });
  }, []);

  return (
    <div className={styles.FileList}>
      <div className={styles.Title}>첨부 파일</div>
      <div className={styles.FileContainer}>
        {data.map((f, index) => {
          return (
            <a
              href={`${process.env.REACT_APP_URL}/api/common/file/${f.name}`}
              target="_blank"
              key={index}
            >
              {f.name}
            </a>
          );
        })}
      </div>
    </div>
  );
}
